@let control = $control();
@let isLoading = $isLoading();
@let fileRestrictions = $fileRestrictions();
@let accept = $accept();

<unity-control-wrapper [control]="control" [description]="$description()" [displayName]="$displayName()" [showHint]="$showHint()">
  <input type="hidden" [formControl]="control" />
  <kendo-fileselect
    [accept]="accept"
    [multiple]="false"
    [restrictions]="fileRestrictions"
    (select)="onSelect($event)"
    (remove)="onRemove()" />
  @if (isLoading) {
    <kendo-progressbar [indeterminate]="true" />
  }
</unity-control-wrapper>
